module.exports = __webpack_public_path__ + "img/icon-device-cellphone.835de6e6.svg";